import { toast } from 'react-hot-toast';
import { useMutation } from '@tanstack/react-query';

import { request } from '@core/api/request';
import { queryClient } from '@core/api/query-client';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';

const BASE_URL = import.meta.env.VITE_APP_API_URL;

export const editResetPassword = async (data: {
  email: string;
  source?: string;
}) => {
  return await request({
    url: 'auth/password/reset/',
    method: 'POST',
    body: data,
    baseURL: BASE_URL,
    params: { source: data.source || 'crm' },
  });
};

export const useEditResetPassword = () => {
  return useMutation({
    mutationFn: editResetPassword,
    onError: (error: string) => {
      toast.error(error);
    },
    onSuccess: () => {
      toast.success('Password reset email sent successfully');
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.getUserById],
      });
    },
  });
};
